import { render, staticRenderFns } from "./wText.vue?vue&type=template&id=067a161a&scoped=true&"
import script from "./wText.vue?vue&type=script&lang=js&"
export * from "./wText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a161a",
  null
  
)

export default component.exports